import { render, staticRenderFns } from "./NewImage.vue?vue&type=template&id=a8883578&scoped=true"
import script from "./NewImage.vue?vue&type=script&lang=js"
export * from "./NewImage.vue?vue&type=script&lang=js"
import style0 from "./NewImage.vue?vue&type=style&index=0&id=a8883578&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8883578",
  null
  
)

export default component.exports